export const PHTaxIssueOptions = {
  audit: { label: 'Audit', value: 'Audit' },
  irs_notice: { label: 'IRS notice', value: 'IRS notice' },
  paying_back_taxes: { label: 'Paying back taxes', value: 'Paying back taxes' },
  something_else: { label: 'Something else', value: 'Something else' }
} as const;
